module.exports = __webpack_public_path__ + "img/rk_gx.07594857.png";